import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext, useSearchParams } from "react-router-dom";
import { useAnalytics } from "@commons-monorepo/index";
import { useAppLocation, getLogoFromMetadata } from "@commons-monorepo/index";
import { mapAboutUsData } from "./about-us.utils";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
export const useAboutUsInformation = () => {
  const { t } = useTranslation();
  const { pathname } = useAppLocation();
  const [searchParams] = useSearchParams();
  const { storeMetadata } = useOutletContext<any>();
  const [logEvent] = useAnalytics({ storeMetadata });
  const dataAboutUs = mapAboutUsData(storeMetadata, searchParams);
  const previewImage = "/prod/personalization/about_us.png";
  const { theme: themeContext } = useGlobalStyles();

  const profilePic = themeContext.logo?.includes("avatarProfile")
    ? previewImage
    : getLogoFromMetadata(storeMetadata) || previewImage;

  const isAboutUsInformationPreview = useMemo(
    () => !!searchParams.get("about-us"),
    [searchParams],
  );

  return {
    t,
    logEvent,
    isAboutUsInformationPreview,
    dataAboutUs,
    pathname,
    profilePic,
  };
};
